import { useRef, useState } from 'react';

import { AutoComplete, Form } from 'antd';
import { useUsers } from 'useSWR';
import useDebouncedValue from 'hooks/useDebouncedValue';
import './style.less';
import useClickOutside from 'hooks/useClickOutside';

import AlertArea from '../AlertArea';

import SearchLabel from './SearchLabel';
import StickyDrawerFooter from './StickyDrawerFooter';
import NotFoundContent from './NotFoundContent';
import AuthorExistModal from './AuthorExistModal';
import NewAuthorModal from './NewAuthorModal';

function AuthorSearch({ handleNewAuthor }) {
  const form = Form.useFormInstance();
  const searchRef = useRef(null);
  const [fullName, setFullName] = useState(null);
  const [authorExistModal, setAuthorExistModal] = useState({
    visible: false,
    user: null,
  });
  const [newAuthorModal, setNewAuthorModal] = useState(false);
  const [openAutoComplete, setOpenAutoComplete] = useState(false);
  const debouncedValue = useDebouncedValue(fullName);

  useClickOutside(searchRef, () => {
    setOpenAutoComplete(false);
  });

  const { users, isLoading } = useUsers({
    pagination: false,
    extras: {
      fullName: debouncedValue,
    },
    enabled: Boolean(debouncedValue),
  });

  function handleAuthorSelect(user) {
    form.setFieldsValue({
      id: user['@id'],
      status: true,
      name: user.firstName,
      surname: user.lastName,
      email1: user.email,
      email2: user.email2,
      email3: user.email3,
      phone: user.phone,
    });
  }

  return (
    <>
      <div ref={searchRef}>
        <AutoComplete
          getPopupContainer={(trigger) => trigger.parentNode}
          dropdownMatchSelectWidth={false}
          className="gx-w-100 gx-mb-3"
          onFocus={() => {
            if (Array.isArray(users?.['hydra:member']) && !openAutoComplete && Boolean(fullName)) {
              setOpenAutoComplete(true);
            }
          }}
          popupClassName="author-search-popup"
          options={
            Array.isArray(users?.['hydra:member']) &&
            Boolean(fullName) &&
            users?.['hydra:member']?.map((user) => {
              const isAuthor = user.roles.includes('ROLE_AUTHOR');

              return {
                value: `${user.firstName} ${user.lastName} (${user.email})`,
                disabled: isAuthor,
                label: (
                  <SearchLabel
                    user={user}
                    isAuthorExist={isAuthor}
                  />
                ),
                option: user,
              };
            })
          }
          open={openAutoComplete && Boolean(fullName.trim())}
          onSearch={(value) => {
            setFullName(value);
            setOpenAutoComplete(true);
          }}
          onSelect={(_, option) => {
            setAuthorExistModal({
              visible: true,
              user: option.option,
            });
            setOpenAutoComplete(false);
          }}
          dropdownRender={(options) => (
            <div className="drawer-wrapper">
              {options}
              <StickyDrawerFooter
                onClick={() => {
                  setNewAuthorModal(true);
                  setOpenAutoComplete(false);
                }}
              />
            </div>
          )}
          notFoundContent={<NotFoundContent loading={isLoading && Boolean(fullName)} />}
          placeholder="Yazar ara"
          allowClear
        />
        <AuthorExistModal
          open={authorExistModal.visible}
          onCancel={() => setAuthorExistModal({ visible: false, user: null })}
          onOk={() => {
            handleNewAuthor(true);
            handleAuthorSelect(authorExistModal.user);
            setAuthorExistModal({ visible: false, user: null });
          }}
          authorInfo={authorExistModal.user}
        />

        <NewAuthorModal
          open={newAuthorModal}
          onCancel={() => {
            setNewAuthorModal(false);
            handleNewAuthor(false);
          }}
          onOk={() => {
            setNewAuthorModal(false);
            handleNewAuthor(true);
          }}
        />
      </div>
      <AlertArea />
    </>
  );
}

export default AuthorSearch;
